import { ContentfulLandingPageType } from 'types';

export const getContentfulLandingPageQuery = (type: ContentfulLandingPageType, slug: string, preview = false) => {
  switch (type) {
    case ContentfulLandingPageType.Alpha:
      return getAlphaLandingPageQuery(slug, preview);
    case ContentfulLandingPageType.Beta:
      return getBetaLandingPageQuery(slug, preview);
    case ContentfulLandingPageType.Unknown:
      return getUnknownLandingPageQuery(slug, preview);
    default:
      console.error('Invalid landing page type', type);
  }
};

const alphaTemplateQuery = (slug: string, preview: boolean) => {
  return `
  alphaTemplatePageCollection(preview:  ${preview ? 'true' : 'false'}, limit: 1, where: {slug: "${slug}"}){
    items{
      sys {
        firstPublishedAt
        publishedAt
      }
      slug,
      displayTitle,
      seoDescription,
      seoTitle,
      hasDirectLink,
      blocksCollection {
      items {
        ... on SharedTemplateBannerBlock {
            image {
                url,
                height,
                width
            },
            responsiveImage {
                url,
                height,
                width
            },
            altText,
            __typename,
        },
        ... on SharedTemplateTextBlock {
            title {
                json
            },
            description {
                json
            },
            titleAlign,
            descriptionAlign,
            type
            __typename,
        }
        ... on SharedTemplateMediaBlock {
          title {
              json
          }
          description {
              json
          }
          image {
            url
          }
          video,
          mediaPosition,
          hasGrayBackground,
          __typename,
        },
        ... on SharedTemplateProductsBlock {
          customListingSlug,
          listingType,
          blockTitle: title,
          isSingleProduct,
          isTitleHidden,
          __typename,
        }
        ... on AlphaTemplateBoxesBlock {
            hasGrayBackground,
            hasPatternBackground,
            itemsCollection {
                items {
                    title,
                    description {
                        json
                    }
                    image {
                        url
                    }
                    disclaimers
                    type
                    buttonText,
                    buttonType,
                    buttonLink,
                    buttonAnalyticsId,
                }
            }
            __typename
        }
        ... on AlphaTemplateHighlightBlock {
            text {
                json
            }
            image {
                url,
                height,
                width
            },
            textSize,
            isImageOutside,
            type
            __typename
          }
        }
      }
    }
  }`;
};

const getAlphaLandingPageQuery = (slug: string, preview: boolean) => `
query {
  ${alphaTemplateQuery(slug, preview)}
}`;

const betaTemplateQuery = (slug: string, preview: boolean) => {
  return `
    betaTemplatePageCollection(preview:  ${preview ? 'true' : 'false'}, limit: 1, where: {slug: "${slug}"}){
      items{
        sys {
          firstPublishedAt
          publishedAt
        }
        slug,
        displayTitle,
        seoDescription,
        seoTitle,
        hasDirectLink,
        footerTitle {
          json
        },
        footerButtonLink,
        footerButtonText
        footerRegulation {
            json
        },
        footerDisclaimer {
            json
        },
        blocksCollection {
          items {
            ... on BetaTemplateDefaultBlock {
              image {
                  url
              },
              title {
                  json
              }
              size,
              description {
                  json
              }
              __typename,
            },
          }
        }
      }
    }`;
};

const getBetaLandingPageQuery = (slug: string, preview: boolean) => `
query {
  ${betaTemplateQuery(slug, preview)}
}`;

const getUnknownLandingPageQuery = (slug: string, preview: boolean) => `
  query {
    ${alphaTemplateQuery(slug, preview)}
    ${betaTemplateQuery(slug, preview)}
  }
`;
